import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from '@deliveroo/consumer-component-library/components/Modal';
import P from '@deliveroo/consumer-component-library/components/P';
import { closeMealCardModal } from '../../actions/mealCardActions';
import { trackIssuerClick } from '../../actions/tracking/mealCards';
import i18n from '../../utils/i18n';

import IssuerList from '../../components/IssuerList';

import styles from './styles.scss';

export class MealCardModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(item) {
    const { error } = this.props;
    this.props.trackIssuerClick(item.name);

    if (item.auth_url && !error) {
      window.location.href = `${item.auth_url}&source=${encodeURIComponent(window.location.href)}`;
    }
  }

  render() {
    const {
      availableMealCards,
      unavailableMealCards,
      showModal,
      closeModal,
      error,
      loading,
    } = this.props;

    return (
      <Modal
        appElement="#__next"
        id="meal-card-modal"
        type="fullscreen"
        isOpen={showModal}
        onClose={closeModal}
        closeButtonLabel={i18n.gettext('closeButton.label')}
        headerTitle={i18n.gettext('ticketrestaurant_issuer_title')}
      >
        {error && (
          <span className={styles.error}>
            <P color="red" spacing="medium 0 medium 0">
              {error.message || i18n.gettext('Something went wrong.')}
            </P>
          </span>
        )}

        {/* Render available meal cards */}

        <IssuerList
          isPlaceholder={loading}
          heading={i18n.gettext('ticketrestaurant_issuer_heading')}
          issuers={availableMealCards}
          handleClick={this.handleClick}
          isAvailable
        />

        {/* Render unavailable meal cards */}

        <IssuerList
          isPlaceholder={loading}
          heading={i18n.gettext('ticketrestaurant_issuer_secondheading')}
          issuers={unavailableMealCards}
          handleClick={this.handleClick}
          error={error}
          isAvailable={false}
        />
      </Modal>
    );
  }
}

MealCardModal.defaultProps = {
  availableMealCards: [],
  unavailableMealCards: [],
  error: null,
  loading: false,
};

MealCardModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  availableMealCards: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  unavailableMealCards: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  error: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  loading: PropTypes.bool,
  trackIssuerClick: PropTypes.func.isRequired,
};

export default connect(
  (state) => ({
    showModal: state.mealCard.showModal,
    availableMealCards: state.mealCard.issuers.filter((item) => !!item.auth_url),
    unavailableMealCards: state.mealCard.issuers.filter((item) => !item.auth_url),
    error: state.mealCard.error,
    loading: state.mealCard.loading,
  }),
  (dispatch) => ({
    closeModal: () => dispatch(closeMealCardModal()),
    trackIssuerClick: (issuer) => dispatch(trackIssuerClick(issuer)),
  }),
)(MealCardModal);
